import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useThemeStore, type ThemeMode } from '../../../stores/index.js';
import { useLocale, type AppLocale } from '../../../i18n/index.js';
import { NotificationSettingsPanel } from './NotificationSettingsPanel.js';

const THEME_OPTIONS: ReadonlyArray<ThemeMode> = ['light', 'dark'];

export function SettingsPage() {
  const { t } = useTranslation('settings');
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.set);
  const { locale, options, setLocale } = useLocale();
  const themeGroupId = useId();
  const langSelectId = useId();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, minHeight: 0, flex: 1 }}>
      <header style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0, flex: 1 }}>{t('title')}</h1>
      </header>

      <section
        aria-labelledby={`${themeGroupId}-h2`}
        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
      >
        <h2 id={`${themeGroupId}-h2`} style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>
          {t('theme.heading')}
        </h2>
        <div
          role="radiogroup"
          aria-labelledby={`${themeGroupId}-h2`}
          style={{ display: 'flex', gap: 16 }}
        >
          {THEME_OPTIONS.map((mode) => (
            <label
              key={mode}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
            >
              <input
                type="radio"
                name={`${themeGroupId}-theme`}
                value={mode}
                checked={theme === mode}
                onChange={() => setTheme(mode)}
              />
              <span>{t(`theme.${mode}`)}</span>
            </label>
          ))}
        </div>
      </section>

      <section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>
          <label htmlFor={langSelectId}>{t('language.heading')}</label>
        </h2>
        <select
          id={langSelectId}
          value={locale}
          onChange={(event) => setLocale(event.target.value as AppLocale)}
          style={{
            height: 32,
            maxWidth: 240,
            borderRadius: 'var(--r-1)',
            border: '1px solid var(--border-1)',
            background: 'var(--bg-1)',
            color: 'var(--fg-1)',
            fontFamily: 'var(--font-ui)',
            fontSize: 14,
            padding: '0 8px',
          }}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </section>

      <section style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>{t('notifications.heading')}</h2>
        <NotificationSettingsPanel />
      </section>
    </div>
  );
}
